import { graphql } from "gql.tada";

export const IconGridFragment = graphql(`
  fragment IconGridFragment on IconGrid {
    _id
    title
    iconsCollection(limit: 32) {
      items {
        _id
        name
        asset {
          url
          contentType
        }
      }
    }
  }
`);
